<!--{{pr | json}}-->
@if (prices && prices.length > 0) {
  @switch (stylePrice) {
    @case ('priceAndLevel') {
      <div
        class="flex flex-row items-start lg:items-center p-2.5 lg:px-[15px] lg:py-[10px] border-b border-[#e0e0e0]
          bg-white gap-2.5 lg:gap-5 min-h-[44px] border-l-[8px]"
          [ngClass]="soldout ? 'soldout-temp' : 'not-soldout-temp'"
        [style.border-left-color]="prices[0].priceLevelColor"
        [libDimOn]="soldout"
        [libDimOpacity]="0.6"
        style="color: black">
        <ng-content select="[checkbox]"></ng-content>

        <!-- Wrapper pour gauche + centre (fusionnés sur mobile) -->
        <div class="flex flex-1 gap-3 lg:gap-5 items-start lg:items-center min-w-0">
          <!-- Zone gauche: Cercle et Titre (Titre masqué sur mobile ici) -->
          <div class="flex flex-row lg:flex-1 items-start lg:items-center gap-3 min-w-0">
            <!-- Cercle coloré -->
            @if (rs) {
              <div
                class="seat-color-pricelevelid-{{ prices[0].priceLevelId }}  w-3 h-3 rounded-full shrink-0 mt-1 lg:mt-0"
                [style.background-color]="soldout ? '#e0e0e0' : prices[0].priceLevelColor"></div>
                
            }

            <div class="desktop-price hidden lg:block flex-1 min-w-0">
              <div class="text-base font-bold leading-tight break-words" [matTooltip]="prices[0].priceLevel">
                @if (showPriceLevelAndPrice) {
                  <div class="priceLevel-title-temp">
                   
                    <span class="template-p-pl-label-temp template-p-pl-label-temp-{{ prices[0].id}}"
                    [ngClass]="prices.length === 1 ? 'template-p-one-price-pl-label-temp' : ''"
                    > {{ prices[0].priceLevel }} </span>
                    @if (prices.length === 1) {
                      <span class="template-p-label-temp template-p-label-temp-{{ prices[0].id}}"> -{{ prices[0].name }}</span>
                    }
                  </div>
                  <div class="priceLevel-title-temp-override-{{ translate.currentLang }}"></div>
                } @else {
                  <div>
                    {{ prices[0].name }}
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- Zone centre: Prix et Titre mobile -->
          <div class="mobile-price  flex-1 lg:flex-none lg:text-right flex flex-col items-start lg:items-end min-w-0">
            <!-- Titre visible uniquement sur mobile -->
            <div class="lg:hidden mb-1">
              @if (showPriceLevelAndPrice) {
                <div class="flex flex-col">
                  <div class="font-bold text-sm leading-tight">
                    <span class="template-p-pl-label-temp template-p-pl-label-temp-{{ prices[0].id}}"
                    [ngClass]="prices.length === 1 ? 'template-p-one-price-pl-label-temp' : ''">{{ prices[0].priceLevel }}</span>
                    @if (prices.length === 1) {
                      <span class="template-p-label-temp template-p-label-temp-{{ prices[0].id}}"> -{{ prices[0].name }}</span>
                    }
                  </div>
                </div>
              } @else {
                <div class="font-bold text-sm leading-tight">
                  {{ prices[0].name }}
                </div>
              }
            </div>

            <div class="flex flex-wrap items-baseline gap-x-2 lg:justify-end">
              @if (prices.length === 1) {
                @if (prices[0].originalPrice > 0) {
                  <span class="text-xs lg:text-sm font-normal text-gray-500 line-through">
                    {{ prices[0].originalPrice / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                  </span>
                }
                <span
                  class="font-bold text-base lg:text-lg"
                  [style.color]="prices[0].originalPrice > 0 && hasPromo ? 'var(--promo-code-color)' : '#3f51b5'">
                  {{ prices[0].price / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                </span>
              } @else {
                @if (original_price_min > 0 || original_price_max > 0) {
                  <span class="text-xs lg:text-sm font-normal text-gray-500">
                    @if (original_price_min > 0) {
                      <span class="line-through">
                        {{ original_price_min / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                      </span>
                    }
                    @if (original_price_max > 0) {
                      @if (original_price_min > 0) {
                        <span>-</span>
                      }
                      <span class="line-through">
                        {{ original_price_max / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                      </span>
                    }
                  </span>
                }
                <span
                  class="font-bold text-base lg:text-lg"
                  [style.color]="
                    original_price_min > 0 || original_price_max > 0 ? 'var(--promo-code-color)' : '#3f51b5'
                  ">
                  @if (original_price_min > 0 || original_price_max > 0) {
                    @if (original_price_min > 0 && original_price_max > 0) {
                      {{ price_min / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}

                      {{ price_max / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                    } @else if (original_price_min > 0) {
                      {{ price_min / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                    } @else {
                      {{ price_max / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                    }
                  } @else {
                    <span>{{ price_min / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }} -</span>

                    <span>
                      {{ price_max / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                    </span>
                  }
                </span>
              }
            </div>

            @if (serviceCharge_min > 0) {
              <span class="text-[11px] text-gray-500 leading-tight">
                {{
                  'checkout.serviceCharge'
                    | translate
                      : {
                          value:
                            serviceCharge_min === serviceCharge_max
                              ? (serviceCharge_min / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang)
                              : (serviceCharge_min / 100
                                  | currency: '' : 'symbol-narrow' : '' : translate.currentLang) +
                                '-' +
                                (serviceCharge_max / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang)
                        }
                }}
              </span>
            }

            @if (
              hasPromo &&
              ((original_price_min == 0 && original_price_max == 0) ||
                (prices.length === 1 && prices[0].originalPrice === 0))
            ) {
              <span class="text-[var(--promo-code-color)] text-[11px] font-medium">
                {{ 'page.promo-applied' | translate }}
              </span>
            }

            <span class="text-[11px] text-gray-400 mt-0.5">
              {{ '' | libTranslateLang: 'Taxes included' : 'Taxes incluses' }}
            </span>
          </div>
        </div>

        <!-- Zone droite: Boutons quantité ou badge COMPLET -->
        <div class="shrink-0 flex flex-col items-end justify-center min-w-0 lg:min-w-[165px]">
          @if (soldout) {
            <div class="px-5 py-2 bg-gray-100 rounded text-gray-400 text-sm font-medium uppercase text-center">
              {{ 'checkout.soldOut' | translate }}
            </div>
          } @else if (prices.length >= 1 && showQty) {
            @if (useTemplateQty) {
              <tw-template-qty
                [price]="prices[0]"
                [priceLevel]="priceLevel"
                [itemHour]="itemHour"
                [validateMaxTickets]="validateMaxTickets"
                [maxQty]="maxQty"
                [minQty]="minQty"></tw-template-qty>
            } @else {
              <ng-content select="[qty]"></ng-content>
            }

            @if (showTotal && prices.length === 1 && prices[0].total) {
              <mat-divider class="w-full my-1"></mat-divider>
              <div class="flex flex-row justify-between items-center w-full font-bold text-sm lg:text-base">
                <span>Total</span>
                <span class="text-[#3f51b5]">
                  {{ prices[0].total / 100 | currency: '' : 'symbol-narrow' : '' : translate.currentLang }}
                </span>
              </div>
            }
          }
        </div>

        @if (prices[0].donation) {
          <ng-content select="[donation]"></ng-content>
        }
      </div>
      <mat-divider></mat-divider>
    }
  }
}
